import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, onBeforeMount } from 'vue';
import { primeSessionFromStorage } from 'src/services/session';
import GlobalHeader from 'src/components/lib/GlobalHeader.vue';
import GlobalFooter from 'src/components/lib/GlobalFooter.vue';
import AuthProvider from 'src/components/lib/AuthProvider.vue';
import MasterProvider from 'src/components/lib/MasterProvider.vue';
import { parseExtParams } from 'src/services/extParams';
import { registerVideojsComponents } from 'src/lib/videojsHelper';
import { providePageType } from 'src/composables/usePageType';
import { provideFullScreenSpinner } from 'src/composables/useFullScreenSpinner';
import { provideEnv } from 'src/composables/useEnv';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

provideEnv();
provideFullScreenSpinner();
const { isGuestPage, isPrintPage, isSpPage } = providePageType();

const showHeader = computed(() => !isGuestPage.value && !isPrintPage.value && !isSpPage.value);

// axios のベース URL とトークンは、子の AuthProvider が getMe する前に確実に
// 設定されている必要があるため、setup で同期的に実行する
primeSessionFromStorage();

onBeforeMount(() => {
  parseExtParams();
  registerVideojsComponents();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(AuthProvider, null, {
    default: _withCtx(() => [
      _createVNode(MasterProvider, null, {
        default: _withCtx(() => [
          (showHeader.value)
            ? (_openBlock(), _createBlock(GlobalHeader, { key: 0 }))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.matched[0]?.path
          })),
          _createVNode(GlobalFooter)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})